import { ReactNode, createElement } from 'react'

type Props = {
  children?: ReactNode
  component?: string
  className?: string
  line?: number
}

const MultiLineOverflowText = ({
  component = 'span',
  line = 1,
  children,
  className,
  ...rest
}: Props) => {
  return createElement(
    component,
    {
      ...rest,
      className: className,
      style: {
        // line breaking with line couting
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: line,
        overflow: 'hidden',
        // fallback
        wordBreak: 'break-all',
        whiteSpace: 'normal',
        textOverflow: 'ellipsis',
      },
    },
    children,
  )
}

export default MultiLineOverflowText
